goog.provide('el8.tourguide.InfoSplash');

goog.require('el8.template.tourguide.InfoSplash');

/**
 * This widget overlays multiple translucent, explanatory boxes on the page.
 * Its primary use is to help explain the page's layout (as opposed to the Splash
 * widget, which is more useful for explaining something general about the page.)
 *
 * To see an example, check out chartInfoSplash.js
 */
el8.tourguide.InfoSplash = function(spec) {
    spec = spec || {};
    this._name = spec.name;
    this._contentFn = spec.contentFn || null;
    this._UILayoutFn = spec.UILayoutFn;
    this._blockSpecs = [];
    this._hideCallbackFn = null;
};

el8.tourguide.InfoSplash.prototype._init = function() {

    if (this._isInit) { return; }
    this._isInit = true;

    /* Lay down an overlay */
    this._container = $(el8.template.tourguide.InfoSplash.overlay({name: this._name}));
    this._drawContents();
    $(document.body).append(this._container);

    /* Bind triggers */
    var that = this;
    this._container.on('click', '.close-trigger',  function() {
        that.hide();
    });

};

el8.tourguide.InfoSplash.prototype.show = function(hideCallbackFn) {
    if (this._isInit) {
        this._container.show();
    } else {
        this._init();
    }
    this._hideCallbackFn = hideCallbackFn || null;
    var that = this;
    that._resizeFn = function() { that._drawContents(); };
    that._UILayoutFn().addResizeListener(that._resizeFn);
    that._escFn = function(e) { if (e.keyCode === KEYS.ESC) { that.hide(); } };
    $(document).on('keydown', that._escFn);

};

el8.tourguide.InfoSplash.prototype.hide = function() {
    if (this._container) {
        this._container.hide();
        if (this._hideCallbackFn) { this._hideCallbackFn(); }
        if (this._resizeFn) {
            this._UILayoutFn().removeResizeListener(this._resizeFn);
        }
        if (this._escFn) {
            $(document).unbind('keydown', this._escFn);
        }
    }
};

el8.tourguide.InfoSplash.prototype._drawContents = function() {
    if (this._contentFn) {
        // Remove old contents, if any
        $('.info-splash-content', this._container).remove();
        this._contentElt = $(this._contentFn());
        this._container.append(this._contentElt);
    }
    if (this._blockSpecs) {
        for (var i=0; i<this._blockSpecs.length; i++) {
            (new el8.tourguide.InfoSplashBlock(this._blockSpecs[i])).drawOn(this._contentElt);
        }
    }
};

el8.tourguide.InfoSplash.prototype.adjustSize = function() {
    this._drawContents();
};

el8.tourguide.InfoSplash.prototype.addBlock = function(spec) {
    this._blockSpecs.push(spec);
};

el8.tourguide.InfoSplash.prototype.getContentElt = function() {
    return this._contentElt;
};

/**
 * Helper object for displaying hover blocks
 */
el8.tourguide.InfoSplashBlock = function(spec) {
    this._anchorSelector = spec.anchorSelector;
    this._contentFn = spec.contentFn || null;
    this._heightFn = spec.heightFn;
    this._widthFn = spec.widthFn;
    this._topOffset = spec.topOffset;
    this._leftOffset = spec.leftOffset;
    this._styleClass = spec.styleClass || 'SplashBlockContainer';
    return this;
};

el8.tourguide.InfoSplashBlock.prototype.drawOn = function($container) {
    var $elt = $(el8.template.tourguide.InfoSplash.block());
    if (this._styleClass) { $elt.addClass(this._styleClass); }
    var $anchor = $(this._anchorSelector);
    $container.append($elt);
    if (this._contentFn) { $elt.append(this._contentFn()); }
    if (this._heightFn) { $elt.outerHeight(this._heightFn($anchor)); }
    if (this._widthFn) { $elt.outerWidth(this._widthFn($anchor)); }
    $elt.css({
        'top': $anchor.offset().top +
            (this._topOffset ? (jQuery.isFunction(this._topOffset) ?
                this._topOffset($anchor) : this._topOffset) : 0),
        'left': $anchor.offset().left +
            (this._leftOffset ? (jQuery.isFunction(this._leftOffset) ?
                this._leftOffset($anchor) : this._leftOffset) : 0)
    });
};
